import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { PointOfSaleSummary, PointOfSaleDetails, PointOfSaleDayTimetable } from './fulle-pointOfSale.service.interface';
import { FulleBaseclientService } from '../../../apiclient/fulle-baseclient.service';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { FulleSaleMethodService } from '../fulle-saleMethod/fulle-saleMethod.service';
import { DeliveryZone } from 'src/app/models/interfaces/address.interface';

@Injectable({ providedIn: 'root' })
export class FullePointOfSaleService {

  banners = [
    {
      activity: 1,
      banner: "restaurant"
    },
    {
      activity: 2,
      banner: "foodtruck"
    },
    {
      activity: 3,
      banner: "fleuriste"
    },
    {
      activity: 4,
      banner: "boulangerie"
    },
    {
      activity: 5,
      banner: "commerce"
    },
    {
      activity: 6,
      banner: "boutique"
    },
    {
      activity: 7,
      banner: "bar"
    },
    {
      activity: 8,
      banner: "coiffeur"
    },
    {
      activity: 9,
      banner: "coiffeur"
    }
  ];

  constructor(
    private fulleBaseclient: FulleBaseclientService,
    private tools: ToolsService,
    private fulleSMApi: FulleSaleMethodService,
  ) { }

  existsPointOfSale(merchantId: number): Promise<boolean> {
    return this.fulleBaseclient.headBaseSlim('points_of_sale', { merchantId: merchantId });
  }

  async getPointOfSaleSummary(
    merchantId: number,
    fieldsList?: string,
    includeList?: string
  ): Promise<PointOfSaleSummary[]> {
    return this.fulleBaseclient
      .getBaseSlim(
        'points_of_sale',
        { merchantId, fields: fieldsList, include: includeList }
      )
      .then(resp => resp.data);
  }

  async getPointOfSaleDetails(
    merchantId: number,
    fieldsList?: string,
    includeList?: string
  ): Promise<PointOfSaleDetails[]> {
    console.log("merchantId : ", merchantId);
    console.log("fieldsList : ", fieldsList);
    console.log("includeList : ", includeList);
    return this.fulleBaseclient.getBaseSlim(
      'points_of_sale/details',
      { merchantId, fields: fieldsList, include: includeList }
    )
      .then(resp => resp.data);
  }

  checkOpening(pointTimetables: PointOfSaleDayTimetable[]): string {
    if (!pointTimetables?.length) return "notSpecified";

    const now = moment();
    const currDay = pointTimetables.find(d => d.day === now.day());
    if (!currDay?.timetables?.length) return "close";

    // Prendre les timeslots par défaut (id_sale_method === 0), sinon tous
    const defaultEntry = currDay.timetables.find(t => t.id_sale_method === 0);
    const timeslots = defaultEntry?.timeslots
      ?? currDay.timetables.flatMap(t => t.timeslots ?? []);

    if (!timeslots.length) return "close";

    for (const slot of timeslots) {
      const start = moment(slot.start, "HH:mm:ss");
      let end = moment(slot.end, "HH:mm:ss");
      if (end.isBefore(start)) end = end.add(1, "day");
      if (now.isBetween(start, end, "minute", "[]")) return "open";
      if (now.isBefore(start)) return start.format("HH:mm");
    }

    return "close";
  }

  setPoint(point: PointOfSaleSummary, same: boolean = false): void {
    if (!same) {
      // On change de POS => on reset la sale method
      // mais on garde le panier si tu veux (à toi de voir la logique produit)
      this.fulleSMApi.removeSaleMeth({ keepCart: true, keepInfoNotes: false });
    }

    this.tools.setStor("point_of_sale", point);
    this.tools.removeStor("date_order");
    this.tools.removeStor("hour_order");
  }

  async getEligibleCities(merchantId: number, pointOfSaleId: number): Promise<DeliveryZone[]> {
    try {
      const data = await this.fulleBaseclient.getBaseSlim(
        `points-of-sale/${pointOfSaleId}/delivery-zones`,
        { merchantId }
      );

      console.log("data : ", data);

      if (data.code === 0) {
        return data.data;
      }

      return []; // Si le code n'est pas 0
    } catch (error) {
      console.error('Erreur lors de la récupération des zones:', error);
      return []; // En cas d'erreur
    }
  }

}
